<template>
  <!-- 工作经历： -->
  <!-- ApplyForAJob和IndividualEdit都等于1时 正常显示求职意向 若有一条不等于1说明用户点击了添加或单条编辑 这时就要展示编辑栏 -->
  <div :class="IndividualEdit == 1 ? 'normal' : 'editor'">
    <div class="Title-Add-box">
      <div class="Title-Add" @click="handelClickEDITOR"></div>
      <p class="Title-p" @click="handelClickEDITOR">添加工作经历</p>
    </div>
    <!-- 正常显示工作经历数据 -->
    <div v-if="IndividualEdit == 1" class="NormalDisplay">
      <!-- 没有工作经历数据显示待添加 -->
      <div class="None firm-clickable" v-if="data.length == 0" @click="handelClickEDITOR">
        待添加
      </div>
      <!-- 有工作经历数据正常展示数据 -->
      <div
        class="normal-show"
        v-else
        v-for="(item, index) in data"
        :key="index"
      >
        <!-- 公司  在职日期 -->
        <div class="top-threeRows">
          <p class="CompanyName">{{ item.companyName }}</p>
          <p>{{ item.startTime }} 至 {{ item.endTime }}</p>
          <div class="icon firm-clickable" @click="handelClickSingle(item, index)"></div>
        </div>
        <!-- 职位 部门 月薪 行业 -->
        <div class="top-threeRows">
          <p>{{ item.positionName }}</p>
          <!-- <p>{{ item.section }}</p> -->
          <p>{{ item.monthlyPay }}</p>
          <p>{{ item.industryTypeName }}</p>
        </div>
        <!-- 技能 -->
        <div class="top-threeRows">
          技能：
          <p
            class="skill"
            v-for="(item1, index) in item.skillNameList"
            :key="index"
          >
            {{ item1 }}
          </p>
        </div>
        <div class="Description">工作描述：</div>
        {{ item.jobEsc }}
        <!-- <ul>
          内容:
          <li v-for="(item2, index) in item.JobContent" :key="index">
            {{ item2 }}
          </li>
        </ul>
        <ul class="ul-performance">
          业绩:
          <li v-for="(item3, index) in item.performance" :key="index">
            {{ item3 }}
          </li>
        </ul> -->
      </div>
    </div>
    <!-- 显示编辑栏 -->
    <div v-if="IndividualEdit == 2" class="StartEditing">
      <div class="EDITOR-top">
        <div class="EDITOR-required">
          <div class="required-title-p">
            <p v-for="(item, index) in titleArr" :key="index">
              <span style="color: red">*</span>
              {{ item }}：
            </p>
          </div>
          <div class="required-ipt">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <!-- 企业名称 -->
              <div class="input-place">
                <el-form-item prop="companyName">
                  <el-autocomplete
                    class="inline-input"
                    v-model="ruleForm.companyName"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入企业名称"
                    :trigger-on-focus="false"
                    @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </div>
              <!-- 所属行业 -->
              <div class="input-place" @click="handelExpect(2)">
                <el-form-item prop="industryTypeName">
                  <el-input
                    v-model="ruleForm.industryTypeName"
                    placeholder="请选择"
                    readonly
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 职位名称 -->
              <div class="input-place" @click="handelExpect(1)">
                <el-form-item prop="positionName">
                  <el-input
                    v-model="ruleForm.positionName"
                    placeholder="请选择"
                    readonly
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 技能 -->
              <div class="input-place" @click="handelIptSkill">
                <el-form-item prop="skillStr">
                  <el-input
                    v-model="ruleForm.skillStr"
                    placeholder="请输入"
                    @blur="blur"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 月薪 -->
              <div class="input-place">
                <el-form-item prop="monthlyPay">
                  <el-input
                    v-model="ruleForm.monthlyPay"
                    placeholder="请输入在职月薪"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 在职时间 -->
              <div class="input-place">
                <el-form-item prop="startTime" style="margin-right: 10px">
                  <el-date-picker
                    v-model="ruleForm.startTime"
                    type="month"
                    placeholder="请选择"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="startTimePickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
                <p>至</p>
                <el-form-item prop="endTime" style="margin-left: 10px">
                  <el-date-picker
                    v-model="ruleForm.endTime"
                    type="month"
                    placeholder="请选择"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="endTimePickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
              <!--  -->
              <div class="input-place">
                <el-form-item prop="jobEsc">
                  <div class="EDITOR-top-ipt">
                    <el-input
                      type="textarea"
                      placeholder="请输入在职期间至少50个字的工作内容"
                      v-model="ruleForm.jobEsc"
                      maxlength="3000"
                      show-word-limit
                      resize="none"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="required-dele" v-if="ApplyForAJob != '1'">
            <div class="firm-clickable" @click="handelDele"></div>
          </div>
        </div>
      </div>
      <!-- 取消确认按钮 -->
      <div class="EDITOR-btm">
        <p class="Cancel" @click="handelUnEdit">取消</p>
        <p class="verify" @click="handelSubmitEdit('ruleForm')">确认</p>
      </div>
    </div>
    <!-- 职位 -->
    <Position
      :PositionAndProfession="PositionAndProfession"
      :positionCode="ruleForm.positionCode"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></Position>
    <!-- 行业 --> 
    <Profession
      :industryTypeList="industryTypeList"
      :singleChoice="2"
      :dialogProfession="dialogProfession"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></Profession>
    <!-- 技能 -->
    <Skill
      :dialogSkill="dialogSkill"
      :skillNameList="ruleForm.skillNameList"
      @handleCloseSkill="dialogSkill = false"
      @handleSkill="handleSkill"
    ></Skill>
  </div>
</template>

<script>
// 引入接口
import {
  addUserWorkExp, // 添加
  editUserWorkExp, // 编辑
  deleteUserWorkExp, //删除
} from "../../../../../../assets/api/CenterJane";
import {
  postGetCompanyListByName, // 根据公司名搜索公司
} from "../../../../../../assets/api/index";
// /职位选择弹窗
import Position from "../../../../../../components/Position.vue";
// /行业选择弹窗
import Profession from "./profession.vue";
// 技能输入弹窗
import Skill from "./Skill.vue";
// 封装的表单验证
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";
export default {
  props: {
    data: {},
  },
  data() {
    return {
      restaurants: [],
      textarea: "", // 工作描述框
      IndividualEdit: 1, // 单条编辑
      titleArr: [
        "企业名称",
        "所属行业",
        "职位名称",
        "拥有技能",
        "在职月薪",
        "在职时间",
        "工作描述",
      ], // 编辑列表

      ruleForm: {
        userId: "",
        companyName: "", // 企业名称
        industryTypeCode: "", // 行业
        industryTypeName: "", // 行业拼接用来展示的名
        positionName: "", // 职位名称
        positionCode: "", // 职位code
        skillStr: "", // 拥有技能
        skillNameList: [], // 拥有技能数组
        monthlyPay: "", // 在职月薪
        startTime: "", // 时间开
        endTime: "", // 时间结束
        jobEsc: "",
      }, // v-mode
      rules: {
        companyName: vxRule(true, "", ["blur", "change"], "请输入企业名称"),
        industryTypeName: vxRule(true, "", ["blur", "change"], "请选择所属行业"),
        positionName: vxRule(true, "", ["blur", "change"], "请选择职位名称"),
        skillStr: vxRule(true, "", ["blur", "change"], "请输入拥有技能"),
        // monthlyPay: vxRule(true, "Email", ["blur", "change"]),
        monthlyPay: [
          {
            required: true,
            message: "请输入在职月薪",
            trigger: ["blur", "change"],
          },
          {
            required: true,

            pattern: /^\d+(\.\d+)?$/,
            message: "请输入数字！",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              const num = Number(value);
              if (isNaN(num)) {
                callback(new Error("请输入有效的数字！"));
              } else if (num > 10000000) {
                callback(new Error("金额偏高！"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        startTime: vxRule(true, "", ["blur", "change"], "请选择在职开始时间"),
        endTime: vxRule(true, "", ["blur", "change"], "请选择在职结束时间"),
        // jobEsc: vxRule(true, "", ["blur", "change"]),
        jobEsc: [
          {
            min: 50,
            required: true,
            message: "请输入至少50字的工作描述！",
            trigger: ["blur", "change"],
          },
        ],
      }, // 表单验证
      ApplyForAJob: "", // 为1时说明是在添加新的求职意向
      index: "", // 点击编辑时获取值，知道编辑的是哪一个
      PositionAndProfession: false, //选择职位弹窗
      dialogProfession: false, //选择行业
      industryTypeList: [{ code: "" }], // 行业 对象形式展示用于传给行业选择组件回显
      dialogSkill: false, //技能输入弹窗
      endTimePickerOptions: {
        disabledDate: (time) => {
          // 如果还没选开始时间 → 不限制
          if (!this.ruleForm.startTime) return false;

          // 已经选了开始时间 → 禁用 早于 startTime 的月份
          const startTime = new Date(this.ruleForm.startTime);
          return time.getTime() < startTime.getTime();
        },
      },
      startTimePickerOptions: {
        disabledDate: (time) => {
          if (!this.ruleForm.endTime) return false;
          const end = new Date(this.ruleForm.endTime);
          return time.getTime() > end.getTime();
        },
      },
    };
  },
  watch: {
    // ... 你原来监听 data 的代码
    "ruleForm.endTime"() {
      // 结束时间变化时，刷新开始时间选择器的禁用状态
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.validateField("startTime");
      }
    },
    "ruleForm.startTime"() {
      // 开始时间变化时，刷新结束时间选择器的禁用状态
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.validateField("endTime");
      }
    },
    // 监听
    data: {
      handler(newSs, old) {
        // 为了方便编辑时技能回显，将技能数组转字符串并赋值给skillStr
        for (var i in newSs) {
          newSs[i].skillStr = newSs[i].skillNameList.toString();
        }
      },
    },
    // // 监听表单验证状态
    // "ruleForm.companyName": function (newSs, old) {
    //   this.rules = {
    //     companyName: vxRule(true, "", "blur"),
    //   }; // 表单验证
    // },
    // "ruleForm.industryTypeName": function (newSs, old) {
    //   this.rules = {
    //     industryTypeName: vxRule(true, "", "blur"),
    //   }; // 表单验证
    // },
    // "ruleForm.positionName": function (newSs, old) {
    //   this.rules = {
    //     positionName: vxRule(true, "", "blur"),
    //   }; // 表单验证
    // },
    // "ruleForm.skillStr": function (newSs, old) {
    //   this.rules = {
    //     skillStr: vxRule(true, "", "blur"),
    //   }; // 表单验证
    // },
    // "ruleForm.monthlyPay": function (newSs, old) {
    //   this.rules = {
    //     monthlyPay: vxRule(true, "", "blur"),
    //   }; // 表单验证
    // },
    // "ruleForm.startTime": function (newSs, old) {
    //   this.rules = {
    //     startTime: vxRule(true, "", "blur"),
    //   }; // 表单验证
    // },
    // "ruleForm.endTime": function (newSs, old) {
    //   this.rules = {
    //     endTime: vxRule(true, "", "blur"),
    //   }; // 表单验证
    // },
    // "ruleForm.jobEsc": function (newSs, old) {
    //   this.rules = {
    //     jobEsc: vxRule(true, "", "blur"),
    //   }; // 表单验证
    // },
  },
  components: {
    Position,
    Profession,
    // 技能输入弹窗
    Skill,
  },
  methods: {
    // 企业名称 模糊搜索
    querySearch(queryString, cb) {
      if (queryString != "" && queryString != null) {
        var data = {};
        data.data = {
          name: queryString,
        };
        postGetCompanyListByName(data, 1, 10).then((res) => {
          for (var i in res.data.list) {
            res.data.list[i].value = res.data.list[i].name;
          }
          this.restaurants = res.data.list;
          var restaurants = this.restaurants;
          var results = queryString
            ? restaurants.filter(this.createStateFilter(queryString))
            : restaurants;

          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(results);
          }, 3000 * Math.random());
        });
      }
    },
    //筛选符合要求的企业名
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        );
      };
    },
    // 选择完毕
    handleSelect(item) {
      console.log(item, "item", this.ruleForm.companyName);
    },
    // 技能确认
    handleSkill(val, str) {
      this.ruleForm.skillNameList = val;
      this.ruleForm.skillStr = str;
      this.dialogSkill = false;
    },

    // 打开技能输入弹窗
    handelIptSkill() {
      console.log(4444);
      this.dialogSkill = true;
    },
    // 添加
    handelClickEDITOR() {
      this.industryTypeList = [{ code: "" }]; // 行业 对象形式展示用于传给行业选择组件回显
      this.ruleForm = {
        userId: "",
        companyName: "", // 企业名称
        industryTypeCode: "", // 行业
        industryTypeName: "", // 行业拼接用来展示的名
        positionName: "", // 职位名称
        positionCode: "", // 职位code
        skillStr: "", // 拥有技能
        skillNameList: [],

        monthlyPay: "", // 在职月薪
        startTime: "", // 时间开
        endTime: "", // 时间结束
        jobEsc: "",
      }; // v-mode
      this.IndividualEdit = "2";

      // this.rules = {
      //   companyName: vxRule(true, "", "blur"),
      //   industryTypeName: vxRule(true, "", "blur"),
      //   positionName: vxRule(true, "", "blur"),
      //   skillStr: vxRule(true, "", "blur"),
      //   monthlyPay: vxRule(true, "", "blur"),
      //   startTime: vxRule(true, "", "blur"),
      //   endTime: vxRule(true, "", "blur"),
      //   jobEsc: vxRule(true, "", blur),
      // }; // 表单验证
      // 选择框数据
      this.ApplyForAJob = "1";
    },
    // 拥有技能失去焦点，将输入的内容分开转为数组
    blur() {
      // 要数组的情况下转数组
      // this.ruleForm.skillList = this.ruleForm.skill.split(" ");
    },
    // --------------------------------------点击选择 职位
    handelExpect(num) {
      // 打开弹窗
      if (num == 1) {
        // 打开职位选择弹窗
        this.PositionAndProfession = true;
      } else if (num == 2) {
        // 打开行业选择
        this.dialogProfession = true;
      }
    },
    // -------------------------------------选择职位 弹窗关闭
    handleClose(num) {
      if (num == 0) {
        // 0关闭职位选择弹窗
        this.PositionAndProfession = !this.PositionAndProfession;
      } else if (num == 1) {
        this.dialogProfession = !this.dialogProfession;
      }
    },
    //-----------------------------------选择职位 弹窗确认
    handleUnderstand(num, val, valTwe) {
      if (num == 0) {
        this.ruleForm.positionName = valTwe;
        this.ruleForm.positionCode = val;
        // 0关闭职位选择弹窗
        this.PositionAndProfession = !this.PositionAndProfession;
      } else if (num == 1) {
        this.ruleForm.industryTypeCode = val;
        this.ruleForm.industryTypeName = valTwe;
        this.industryTypeList[0].code = val;
        this.dialogProfession = !this.dialogProfession;
      }
    },

    // 点击编辑单条数据
    handelClickSingle(item, index) {
      this.index = item.id; // 获取要编辑的数据位置
      let newArr1 = JSON.parse(JSON.stringify(item)); //拷贝
      this.industryTypeList[0].code = newArr1.industryTypeCode;
      this.ruleForm = newArr1; // 赋值回显拷贝的值，在修改时取消修改不会改变原数据
      this.IndividualEdit = 2;
      this.ApplyForAJob = ""; //
    },
    // 点击清除
    handelDele() {
      this.$confirmWithScroll("是否删除本条信息?", "提示").then(() => {
        var data = {
          data: {
            userId: this.$store.getters.getUser.id,
            id: this.index,
          },
        };
        deleteUserWorkExp(data).then((res) => {
          if (res.code == 0) {
            this.IndividualEdit = 1;
            this.ApplyForAJob = "";
            this.index = "";
            this.$emit("handelSubmitEdit");
            this.$tool.PromptBox("success", "修改成功");
          }
        });
      }).catch(() => {});
    },
    // 取消编辑
    handelUnEdit() {
      this.$emit("handelUnEdit", 4);
      // 点击取消时在子组件内先关闭子组件的展开编辑数据this.IndividualEdit
      this.IndividualEdit = 1;
    },
    // 编辑提交
    handelSubmitEdit(formName) {
      // 表单校验
      //if (valid) 校验成功 调接口继续下一步
      //else 校验失败  return false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm.jobEsc.length);
          if (this.ruleForm.jobEsc.length >= 50) {
            if (this.ApplyForAJob == "") {
              // 为编辑
              var data = {};
              this.ruleForm.id = this.index;
              this.ruleForm.userId = this.$store.getters.getUser.id;
              data.data = this.ruleForm;

              // 调用接口修改简历个人信息
              editUserWorkExp(data).then((res) => {
                if (res.code == 0) {
                  this.IndividualEdit = 1;
                  this.ApplyForAJob = "";
                  this.index = "";
                  this.$emit("handelSubmitEdit");
                  // 成功
                  this.$tool.PromptBox("success", "修改成功");
                  // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
                } else {
                  // 失败
                  // this.$tool.PromptBox("error", res.msg);
                }
              });
            } else {
              // 为添加，在原来的数据前新增一条
              var data = {};
              this.ruleForm.userId = this.$store.getters.getUser.id;
              data.data = this.ruleForm;

              // 调用接口修改简历个人信息
              addUserWorkExp(data).then((res) => {
                if (res.code == 0) {
                  this.IndividualEdit = 1;
                  this.ApplyForAJob = "";
                  this.index = "";
                  this.$emit("handelSubmitEdit");
                  // 成功
                  this.$tool.PromptBox("success", "修改成功");
                  // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
                } else {
                  // 失败
                  // this.$tool.PromptBox("error", res.msg);
                }
              });
            }
          } else {
            this.$tool.PromptBox("warning", "至少输入50字的工作描述");
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
// 文本输入框的样式
/deep/.el-textarea {
  min-height: 130px !important;
  width: 500px;
}
/deep/.el-textarea__inner {
  min-height: 130px !important;
}
/deep/.el-form-item {
  width: 100%;
  margin-bottom: 0px;
  height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
// 修改el组件库中input框中自带的icon
/deep/.el-input__icon {
  font-size: 20px !important;
  margin-top: -3px;
}
// 远程搜索框的宽
.el-autocomplete {
  width: 100%;
}
// 修改el组件库中input框的样式
/deep/.el-input__inner {
  width: 100% !important;
  height: 35px;
  border: 1px solid #409eff ;
  border-radius: 5px;
  //   border-right: none;
}
// 修改el组件库中文本输入框的最小高度
/deep/.el-textarea {
  min-height: 30px !important;
}
// 正常显示数据的 大div
.normal {
  width: 100%;
  min-height: 25px;
  position: relative;
  border: 1px solid transparent;
}
// 显示编辑栏的 大div
.editor {
  width: 100%;
  min-height: 25px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
  position: relative;
}
// 添加icon样式
.Title-Add-box {
  display: flex;
  position: absolute;
  font-size: 12px;
  top: -45px;
  left: 120px;
}
.Title-Add {
  width: 18px;
  height: 18px;
  background-image: url("../../../../../../assets/imgs/tianjia@2x.svg");
  background-size: 100% 100%;
  margin: auto 0;
  margin-left: 30px;
  margin-right: 5px;
}
.EDITOR-Description {
  height: 150px;
}
// 正常展示
.NormalDisplay {
  width: 100%;
  display: flex;
  flex-direction: column;
  // 无数据
  .None {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px dashed #409eff ;
    border-radius: 5px;
    font-size: 12px;
    color: #333333;
    font-weight: 400;
  }
  .normal-show:nth-child(1) {
    margin-top: 0px;
  }
  // 有数据正常展示
  .normal-show {
    width: 900px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    overflow-wrap: break-word;
    margin-top: 40px;
    // 工作经历 上三行   公司名 ，职位部门月薪，技能
    .top-threeRows {
      width: 100%;
      height: 25px;
      line-height: 25px;
      margin-bottom: 8px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #333333;
      font-weight: 400;
      display: flex;

      p {
        margin-right: 20px;
      }
      .skill {
        min-width: 65px;
        height: 23px;
        background: #eeeeee;
        border-radius: 5px;
        text-align: center;
        margin-right: 10px;
      }
      .CompanyName {
        font-size: 16px;
        // font-weight: 600;
      }
      .icon {
        width: 18px;
        height: 18px;
        margin: auto 0;
        background-image: url("../../../../../../assets/imgs/bianji@3x.svg");
        background-size: 100% 100%;
      }
    }
    // 工作描述
    ul {
      font-size: 12px;
    }
    .ul-performance {
      margin-top: 15px;
    }
    .Description {
      margin-bottom: 10px;
      font-size: 12px;
    }
  }
}
// 开始编辑
.StartEditing {
  flex: 1;
  margin: 30px 20px 20px 30px;
  display: flex;
  flex-direction: column;
  .EDITOR-top {
    width: 100%;
    margin-bottom: 20px;
    .EDITOR-required {
      width: 100%;
      min-height: 30px;
      display: flex;
      .required-title-p {
        min-width: 50px;
        text-align: right;
        p {
          height: 35px;
          line-height: 35px;
          margin-bottom: 25px;
          font-size: 14px;
          color: #333333;
          font-weight: 400;
        }
      }
      .required-ipt {
        width: 350px;
        .input-place {
          width: 100%;
          height: 35px;
          margin-top: 25px;
          display: flex;
          position: relative;
          p {
            width: 60px;
            line-height: 35px;
            text-align: center;
            font-size: 14px;
          }
        }
        .input-place:nth-child(1) {
          margin-top: 0;
        }
        .input-place:nth-child(7) {
          height: 150px;
        }
      }
      .required-dele {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        div {
          width: 20px;
          height: 20px;
          background-image: url("../../../../../../assets/imgs/shanchu@3x.svg");
          background-size: 100% 100%;
        }
      }
    }
    .EDITOR-Description {
      width: 100%;
      min-height: 30px;
      p {
        flex: 1;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        margin-bottom: 5px;
      }
    }
  }

  // 编辑栏下方按钮
  .EDITOR-btm {
    width: 100%;
    height: 40px;
    // margin-top: 20px;
    display: flex;
    justify-content: flex-end;

    .Cancel {
      box-sizing: border-box;
      border: 1px solid #999999;
      color: #333333;
      margin-right: 20px;
      cursor: pointer;
    }
    .verify {
      background: #409eff ;
      color: #ffffff;
      cursor: pointer;
    }
    p {
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
